import * as actionTypes from '../../action/smtp/Smtp'

const initialState = {
    error: false,
    isFetching: false,
    errormessage: ''
}

const reducer = (state = initialState, action) => {
    switch ( action.type ){
        case actionTypes.GET_SMTP_FETCH:
            return {
                ...state,
                isFetching: true
            };
        case actionTypes.GET_SMTP_SUCCESS :
            return {
                ...state,
                isFetching: false,
                error: false,
                smtp: action.payload
            };
        
        case actionTypes.GET_SMTP_FAILURE :
            return {
                ...state,
                isFetching: false,
                error: action.payload
            };
        
        case actionTypes.GET_SMTP_MESSAGE:
            return {
                ...state,
                isFetching: false,
                error: false,
                errormessage: action.payload
            };
        
        default:
            return state;
    }
}

export default reducer;